import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
// import asyncComponent from './../hoc/asyncComponent/asyncComponent';
import ChangePassword from "../pages/login/ChangePassword";
import Login from "../pages/login/Login";
// import Help from "../pages/help/Help";
import TwoFactorAuth from "../pages/login/OtpReceive";
import VerifyMobileNumber from "../pages/login/MobileNumberVerification";
import EmployeeNumberEntry from "../pages/enterprise/EmployeeNumberEntry";
import axios from "../axios";
import TriviaEditPublic from "../pages/trivia/TriviaEditPublic";
import {
  INVALID_REDIRECT_PATHNAMES,
  isTrivvyProduct,
  navigate_user_to_module,
  NO_CONTENT_MESSAGE,
  resizeImageFromUrl,
  isTrivvyUrl
} from "../utils/constants";
import { isBwaiScope } from "../utils/bwaiScope";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as url from "../utils/url";
import * as actionCreators from "../modules/actions/index";
import ResetPassword from "../pages/login/ResetPassword";
import FindOrg from "../pages/login/FindOrg";
import SSO from "../components/SingleSignOn/SSO";
import ResetLinkSent from "../pages/login/ResetLinkSent";
import SetPassword from "../pages/login/SetPassword";
import AdminHome from "./Home/Home";
import ManagerHome from "./ManagerHome/ManagerHome";
import MobileLayoutBoundary from "../hoc/MobileLayoutBoundary/MobileLayoutBoundary";
import FreeDani from "../pages/dani/FreeDani";
import Terms from "../pages/terms/Terms";

import OfficeSetup from "./OfficeSetup/OfficeSetup";
import AudioLinkRedirect from "../pages/public/AudioLink/AudioLinkRedirect";
import VideoLinkRedirect from "../pages/public/VideoLink/VideoLinkRedirect";
import PublicTool from "../pages/public/Tool/PublicTool";
import ShortLinkRedirect from "../pages/public/ShortLink/ShortLinkRedirect";
import LibraryShareView from "../pages/public/LibraryShare/LibraryShareView";
import { getLoginUrlFor, getPostLoginRedirect } from "../utils/postLoginRedirect";
import StartChat from "../pages/public/StartChat";
import MessageAttachmentRedirect from "../pages/public/MessageAttachment/MessageAttachmentRedirect";
import ReactGA from "react-ga";
import { Mixpanel } from "../utils/mixpanelUtils";
import { toastContainer, dismissToast } from "../utils/toast";
import InvalidWorkspaceMessages from "../components/SlackTeamsErrorMessagesUI/InvalidWorkspaceMessages";
import AuthErrorMessage from "../components/SlackTeamsErrorMessagesUI/AuthErrorMessage";
import TriviaQuizPage from "../pages/trivia/Quiz/TriviaQuizPage";
import Signup from "../pages/SignupFromWix/Signup";
import SubscriptionPayment from "../pages/SignupFromWix/SubscriptionPayment";
import DEIMaturityModel from "../pages/DEIMaturityModel/DEIMaturityModel";
// const asyncAdminHome = asyncComponent(() => {
// 	return import('../container/AdminHome/AdminHome');
// });
import trivvyLogo from "../assets/trivvy/trivvy-logo-img.png"
import Hotjar from '@hotjar/browser';
import HotjarC from './Hotjar'
import UserSMSChats from "../pages/dani/TriviaMessageHelp/UserSMSChats";
import UserAllChats from "../pages/dani/TriviaMessageHelp/UserAllChats";
import moment from 'moment';
import { isAndroidDesktopMode } from "../utils/deviceInfo";
import AndroidDesktopViewModal from "../components/AndroidDesktopViewModal";

const UserActivityTracker = withRouter(class extends Component {
  constructor(props) {
    super(props);
    this.warningTimeout = null;
    this.logoutTimeout = null;
    this.warningToastVisible = false;
    this.lastActivity = Date.now();

    // const TESTING_MODE = process.env.NODE_ENV === 'development';

    // if (TESTING_MODE) {
    //   this.WARNING_MINUTES = 10 * 1000; // 30 seconds
    //   this.LOGOUT_MINUTES = 20 * 1000; // 1 minute
    // } else {
    this.WARNING_MINUTES = 9 * 60 * 1000; // 9 minutes
    this.LOGOUT_MINUTES = 10 * 60 * 1000; // 10 minutes
    // }

    // Events to track user activity
    this.activityEvents = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ];

    this.resetInactivityTimers = this.resetInactivityTimers.bind(this);
    this.clearInactivityTimers = this.clearInactivityTimers.bind(this);
    this.performLogout = this.performLogout.bind(this);
    this.isUserAuthenticated = this.isUserAuthenticated.bind(this);
    this.throttledResetTimers = this.throttledResetTimers.bind(this);
  }

  componentDidMount() {
    if (this.isUserAuthenticated()) {
      this.setupActivityListeners();
      this.resetInactivityTimers();
    }
  }

  componentDidUpdate(prevProps) {
    // Set up or tear down listeners based on authentication status
    if (this.props.isAuthenticated !== prevProps.isAuthenticated) {
      if (this.props.isAuthenticated) {
        console.log('User authenticated - setting up activity tracking');
        this.setupActivityListeners();
        this.resetInactivityTimers();
      } else {
        console.log('User logged out - removing activity tracking');
        this.removeActivityListeners();
        this.clearInactivityTimers();
      }
    }
  }

  componentWillUnmount() {
    this.removeActivityListeners();
    this.clearInactivityTimers();
  }

  setupActivityListeners() {
    this.activityEvents.forEach(event => {
      document.addEventListener(event, this.throttledResetTimers, true);
    });
  }

  removeActivityListeners() {
    this.activityEvents.forEach(event => {
      document.removeEventListener(event, this.throttledResetTimers, true);
    });
  }

  // Throttle the reset function to avoid too many calls
  throttledResetTimers() {
    const now = Date.now();
    if (now - this.lastActivity > 1000) {
      this.lastActivity = now;
      this.resetInactivityTimers();
    }
  }

  isUserAuthenticated() {
    const token = localStorage.getItem("AutherizationToken");
    if (!token || token === "sdjnsc" || token === null || token === "") {
      return false;
    }

    return this.props.isAuthenticated;
  }

  clearInactivityTimers() {
    clearTimeout(this.warningTimeout);
    clearTimeout(this.logoutTimeout);
    if (this.warningToastVisible) {
      dismissToast();
      this.warningToastVisible = false;
    }
  }

  performLogout() {
    console.log('Performing logout due to user inactivity');
    this.clearInactivityTimers();

    const { user } = this.props;

    if (user && user.login_time) {
      const { login_time, geo } = user;
      const logout_time = moment();
      const duration = moment.duration(logout_time.diff(moment(login_time)));

      const payload = {
        login_time,
        logout_time,
        org_id: user.organizationId._id,
        org_name: user.organizationId.name,
        geo,
        duration: duration._data,
        miliseconds: duration._milliseconds,
      };

      this.props.onLogoutSuccess();

      axios
        .put(url.logoutUser, payload)
        .then(({ data }) => {
          console.log('LOGGED OUT DUE TO USER INACTIVITY');
        })
        .catch((error) => {
          console.log('Logout API call failed, but proceeding with logout');
        })
        .finally(() => {
          this.props.history.push("/");
        });
    } else {
      this.props.onLogoutSuccess();
      this.props.history.push("/");
    }
  }

  resetInactivityTimers() {
    if (!this.isUserAuthenticated()) {
      return;
    }

    // Skip entirely if running on localhost
    //  console.log('window -- ', window)
    if (window.location.hostname === "localhost") {
      return;
    }

    this.clearInactivityTimers();

    // Calculate remaining time after warning
    const remainingTime = Math.ceil((this.LOGOUT_MINUTES - this.WARNING_MINUTES) / 1000);
    const timeUnit = remainingTime > 60 ? `${Math.ceil(remainingTime / 60)} minute(s)` : `${remainingTime} seconds`;

    this.warningTimeout = setTimeout(() => {
      if (!this.isUserAuthenticated()) {
        return;
      }
      // console.log('Showing inactivity warning');
      toastContainer(`Your session will expire in ${timeUnit} due to inactivity.`, "error");
      this.warningToastVisible = true;
    }, this.WARNING_MINUTES);

    this.logoutTimeout = setTimeout(() => {
      if (!this.isUserAuthenticated()) {
        return;
      }
      // console.log('User inactive for specified time, logging out');
      toastContainer("You have been logged out due to inactivity.", "error");
      setTimeout(() => {
        this.performLogout();
      }, 5000);
    }, this.LOGOUT_MINUTES);
  }

  render() {
    return null;
  }
});

const ToastDismissalHandler = withRouter(class extends Component {
  componentDidMount() {
    // console.log('ToastDismissalHandler mounted - setting up history listener');
    this.unlisten = this.props.history.listen((location, action) => {
      // console.log('Route changed:', location.pathname, 'Action:', action);
      dismissToast();
    });
  }

  componentWillUnmount() {
    // console.log('ToastDismissalHandler unmounting - cleaning up listener');
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    return null;
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      showAndroidDesktopModal: false,
    };
  }

  /* Gates the bwai banner and hover-tooltip styling. A root marker is the only
     practical scope: alerts are plain reactstrap and there are 112 tooltips. */
  syncBwaiProductClass = () => {
    if (isBwaiScope()) {
      document.body.classList.add("bwai-trivvy");
    } else {
      document.body.classList.remove("bwai-trivvy");
    }
  };

  componentDidMount() {
    const { history } = this.props;

    if (window.location.hostname === 'trivvy.ouroffice.io') {

      Hotjar.init(4935459, 6, {
        debug: true
      });

    }

    const pathName = history.location && history.location.pathname;

    if (INVALID_REDIRECT_PATHNAMES.includes(pathName)) {
      toastContainer(NO_CONTENT_MESSAGE, "error");
    }

    /* Re-synced on every navigation, not just at mount: isTrivvyProduct() reads
       the URL, and App never remounts, so a one-shot add would desync. */
    this.syncBwaiProductClass();
    this.unlistenBwaiProduct = history.listen(() => {
      this.syncBwaiProductClass();
    });

    if (isTrivvyProduct()) {
      let faviconImg = document.querySelector("#favicon");
      resizeImageFromUrl(trivvyLogo, 200, 200, (data) => {
        faviconImg.setAttribute("href", data);
      });

      let htmlTitle = document.querySelector(".html-tab-title");
      htmlTitle.innerText = "Trivvy";
    }


    if (!this.props.isAuthenticated && history.location.pathname && history.location.pathname.indexOf("/home/stories/") >= 0) {
      this.props.setAfterLoginUrl(history.location.pathname)
    }

    if (isAndroidDesktopMode()) {
      this.setState({ showAndroidDesktopModal: true });
    }
  }

  componentWillUnmount() {
    if (this.unlistenBwaiProduct) {
      this.unlistenBwaiProduct();
    }
  }

  componentWillReceiveProps(nextProps) {

    if (window.location.hostname === 'trivvy.ouroffice.io') {

      Hotjar.init(4935459, 6, {
        debug: true
      });

    }

    console.log('APP js will receive')
    // console.log(this.props, '----', window.location)
    // this.props.history.listen((location, action) => {
    // 	// location is an object like window.location
    // 	console.log('loc---', location)
    // 	})
    // if(this.props && this.props.user){
    // Mixpanel.track('Page View', {
    // 	page_view: window.location.pathname + window.location.search,
    // 	org_id: this.props.user.organizationId._id,
    // 	org_name:this.props.user.organizationId.name
    // })
    // }
  }
  componentDidUpdate(prevProps) {
    let { user } = this.props;
    if (prevProps.user != user) {
      this.setState({ user });
    }
  }



  render() {
    // console.log('isAuthenticated----', this.props.isAuthenticated)
    // Only the fully set-up branch below routes /home to AdminHome.
    let hasAdminHomeRoute = false;
    let routes = (
      <Switch>
        <Route exact path={"/login"} component={Login} />
        <Route
          exact
          path={"/home/trivia/:orgId/public/:id/:tab"}
          component={TriviaEditPublic}
        />
        <Route
          exact
          path={"/home" + "/trivia/:orgId/quiz/:surveyId/:block"}
          render={(props) => <TriviaQuizPage {...props} isOpenQuiz={true} />}
        />
        <Route path={"/maturity-model/external"} component={DEIMaturityModel} />
        <Route exact path={"/assistant/:phoneNumber/all"} component={UserAllChats} />
        <Route path={"/assistant/:phoneNumber/:date"} component={UserSMSChats} />
        <Route exact path={'/two-factor-authentication'} component={TwoFactorAuth} />
        <Route exact path={'/verify-mobile'} component={VerifyMobileNumber} />
        <Route exact path={'/employee-register'} component={EmployeeNumberEntry} />
        <Route exact path={'/start-chat'} component={StartChat} />
        <Route exact path={"/sso-callback"} component={SSO} />
        <Route exact path={"/reset-password"} component={ResetPassword} />
        <Route exact path={"/terms"} component={Terms} />

        <Route exact path={"/find-enterprise"} component={FindOrg} />
        <Route exact path={"/reset-link-sent"} component={ResetLinkSent} />
        <Route exact path={"/set-password"} component={SetPassword} />
        <Route exact path={"/trivvy-signup-organization"} component={Signup} />
        <Route exact path={"/a/:code"} component={AudioLinkRedirect} />
        <Route exact path={"/v/:code"} component={VideoLinkRedirect} />
        <Route exact path={"/public-tool/:id"} component={PublicTool} />
        <Route exact path={"/:prefix(t|l|r)/:code"} component={ShortLinkRedirect} />
        <Route exact path={"/library-share/:code"} component={LibraryShareView} />
        <Route exact path={"/m/:token"} component={MessageAttachmentRedirect} />
        <Redirect from="/sarv" to="/homa" />
        <Redirect from="/sarvi" to="/homa" />
        <Route
          exact
          // path={"/sarv"} component={Dani}
          path={"/homa"}
          component={FreeDani}
        // {props => <Dani {...props} renderInPage />}
        />
        {/* A protected page opened while logged out: log in, then return to it. */}
        <Route render={({ location }) => <Redirect to={getLoginUrlFor(location)} />} />
        {/* <Redirect exact path={'/'} to={'/login'} /> */}
      </Switch>
    );

    if (
      this.props.isAuthenticated &&
      !this.props.user.isProfileDetailsUpdated
    ) {
      routes = (
        <Switch>
          <Route exact path={"/a/:code"} component={AudioLinkRedirect} />
          <Route exact path={"/v/:code"} component={VideoLinkRedirect} />
          <Route exact path={"/public-tool/:id"} component={PublicTool} />
          <Route exact path={"/:prefix(t|l|r)/:code"} component={ShortLinkRedirect} />
          <Route exact path={"/library-share/:code"} component={LibraryShareView} />
          <Route exact path={"/m/:token"} component={MessageAttachmentRedirect} />
          <Route path={"/setup"} component={OfficeSetup} />
          {/* <Route path={'/home'} component={AdminHome} /> */}
          <Route path={"/manager"} component={ManagerHome} />
          {/* <Route path={'/help'} component={Help} /> */}

          <Route exact path={"/login"} component={Login} />
          <Route exact path={"/signup-organization"} component={Signup} />
          <Route exact path={"/public/okta"} component={Login} />
          <Route exact path={"/reset-password"} component={ResetPassword} />
          <Route exact path={"/terms"} component={Terms} />

          <Route exact path={"/reset-link-sent"} component={ResetLinkSent} />
          <Route exact path={"/set-password"} component={SetPassword} />
          <Route exact path={"/change-password"} component={ChangePassword} />
          <Route exact path={"/subscribe-plan"} component={SubscriptionPayment} />
          <Route exact path={'/employee-register'} component={EmployeeNumberEntry} />
          <Route exact path={'/start-chat'} component={StartChat} />
          {/* <Redirect exact path={'/'} to={'/home'}/> */}
          <Redirect exact path={"/index.html"} to={"/setup"} />
          <Redirect exact path={"/home"} to={"/setup"} />
          <Redirect exact path={"/"} to={"/setup"} component={OfficeSetup} />

          <Redirect from="*" to={"/setup"} />
          {/* <Redirect exact path={'/login'} to={'/home'}/> */}
        </Switch>
      );
    }

    if (
      this.props.isAuthenticated &&
      (this.props.user.isPasswordChanged || this.props.user.isSSO) &&
      this.props.user.isProfileDetailsUpdated
    ) {

      let homeRedirectRoute =
        "/home" + navigate_user_to_module(this.props.user.organizationId, true, this.props.user.orgAdmin);

      if (this.props.returnUrlAfterSlackOrTeamsAuth) {
        homeRedirectRoute = this.props.returnUrlAfterSlackOrTeamsAuth;
      }

      const org = this.props.user.organizationId;

      // if (org.isSignedUpFromTrivvyWebsite) {
      if (isTrivvyUrl(this.props.user.organizationId)) {
        if ((this.props.user.role === "Admin" && this.props.user.orgAdmin === true) || this.props.user.role === "Admin") {
          homeRedirectRoute = `/home/trivia/${org._id}/list`;
        } else {
          // Non-admin users land on Library tab
          homeRedirectRoute = `/home/trivia/${org._id}/library`;
        }
      } else {
        if (this.props.user && this.props.user.organizationId && this.props.user.organizationId._id === "5c421619363d02090ea4b9a6" && this.props.user.organizationId.allowedSlackWorkspaces.length == 0) {
          homeRedirectRoute = "/home/dani/slack-app-install"
        }
        if (this.props.user && this.props.user.organizationId && this.props.user.organizationId.startPage) {
          homeRedirectRoute = this.props.user.organizationId.startPage
        }
      }
      if (this.props.afterLoginRedirect) {
        homeRedirectRoute = this.props.afterLoginRedirect;
      }
      // The page the user was sent to log in from (/login?redirect=…, e.g. a
      // Library item link) wins over the default tab.
      const postLoginRedirect = getPostLoginRedirect(this.props.user);
      if (postLoginRedirect) {
        homeRedirectRoute = postLoginRedirect;
      }

      hasAdminHomeRoute = true;


      routes = (
        <Switch>
          <Route exact path={"/a/:code"} component={AudioLinkRedirect} />
          <Route exact path={"/v/:code"} component={VideoLinkRedirect} />
          <Route exact path={"/public-tool/:id"} component={PublicTool} />
          <Route exact path={"/:prefix(t|l|r)/:code"} component={ShortLinkRedirect} />
          <Route exact path={"/library-share/:code"} component={LibraryShareView} />
          <Route exact path={"/m/:token"} component={MessageAttachmentRedirect} />
          <Route path={"/setup"} component={OfficeSetup} />
          <Route path={"/home"} component={AdminHome} />
          <Route path={"/manager"} component={ManagerHome} />
          {/* <Route path={'/help'} component={Help} /> */}
          <Route path={"/auth-invalid-workspace"} component={InvalidWorkspaceMessages} />
          <Route path={"/share-auth-error"} component={AuthErrorMessage} />

          {/* <Route exact path={'/login'} component={Login} /> */}
          <Route exact path={"/reset-password"} component={ResetPassword} />
          <Route exact path={"/terms"} component={Terms} />

          <Route exact path={"/reset-link-sent"} component={ResetLinkSent} />
          <Route exact path={"/set-password"} component={SetPassword} />
          <Route exact path={"/change-password"} component={ChangePassword} />
          <Route exact path={'/employee-register'} component={EmployeeNumberEntry} />
          <Route exact path={'/start-chat'} component={StartChat} />
          <Redirect exact path={"/"} to={homeRedirectRoute} />
          <Redirect exact path={"/index.html"} to={homeRedirectRoute} />
          <Redirect exact path={"/login"} to={homeRedirectRoute} />
          <Redirect
            from="/homeundefined"
            to={
              "/home" +
              `/${this.props.user.organizationId._id}/profile/${this.props.user._id}`
            }
          />
          <Redirect
            from="/undefined"
            to={
              "/home" +
              `/${this.props.user.organizationId._id}/profile/${this.props.user._id}`
            }
          />
          <Redirect from="*" to={homeRedirectRoute} />
        </Switch>
      );
    }

    return (
      <div>
        <ToastContainer
          position="bottom-right"
          autoClose={50000}
          hideProgressBar={true}
          newestOnTop={true}
          icon={false}
        />
        <HotjarC />
        <Router>
          <>
            <ToastDismissalHandler />
            <UserActivityTracker
              isAuthenticated={this.props.isAuthenticated}
              user={this.props.user}
              onLogoutSuccess={this.props.onLogoutSuccess}
            />
            {/* Every route remounts on a layout switch except AdminHome, which handles its own:
                remounting it would re-register its axios interceptors. The location has to come
                from this inner Router: App's own location prop goes stale on in-app navigation. */}
            <Route
              render={({ location }) => {
                const isAdminHomePath =
                  location.pathname === "/home" || location.pathname.indexOf("/home/") === 0;
                return (
                  <MobileLayoutBoundary
                    render={(layoutKey) => (
                      <React.Fragment key={hasAdminHomeRoute && isAdminHomePath ? "admin-home" : layoutKey}>
                        {routes}
                      </React.Fragment>
                    )}
                  />
                );
              }}
            />
            <AndroidDesktopViewModal
              isOpen={this.state.showAndroidDesktopModal}
              toggle={() => this.setState({ showAndroidDesktopModal: false })}
            />
          </>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.user.profile.autherizationToken ? true : false,
    user: state.user.profile,
    returnUrlAfterSlackOrTeamsAuth: state.user.returnUrlAfterSlackOrTeamsAuth,
    afterLoginRedirect: state.user.afterLoginRedirect
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogoutSuccess: (data) => dispatch(actionCreators.logout()),
    setReturnUrlAfterSlackTeamsAuth: (data) =>
      dispatch(actionCreators.setReturnUrlAfterSlackTeamsAuth(data)),
    setAfterLoginUrl: (data) =>
      dispatch(actionCreators.setAfterLoginUrl(data)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
